import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { currencyActions } from "./actions/currencies.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class Currency extends Component {
  componentDidMount() {
    this.getCurrency();
  }

  componentWillUnmount() {
    this.props.resetCurrency();
  }

  getCurrency = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCurrency(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const currency = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link className="btn btn-outline btn-primary" to={routeConstants.CURRENCIES.path}>
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Currency: {currency && currency.name}{" "}
                  <Button
                    onClick={this.getCurrency}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              <dt className="col-sm-3">Currency</dt>
              <dd className="col-sm-9">
                {currency ? (
                  currency.name
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Currency Alpha Code</dt>
              <dd className="col-sm-9">
                {currency ? (
                  currency.alphaCode
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Currency Numeric Code</dt>
              <dd className="col-sm-9">
                {currency ? (
                  currency.numericCode
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CURRENCIES.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewCurrency;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCurrency: bindActionCreators(
      currencyActions.getCurrency,
      dispatch
    ),
    resetCurrency: bindActionCreators(
      currencyActions.resetCurrency,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Currency);
